var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHandshake(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 433,
    height: 430,
    viewBox: "0 0 433 430",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2472_1937)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M289.438 25.0239C289.438 25.0239 217.568 -1.74667 147.857 38.548C78.1375 78.8517 43.7164 160.158 14.1051 225.27C-15.5152 290.383 2.82843 357.216 56.8202 388.276C110.803 419.328 146.702 375.012 221.886 373.785C297.069 372.558 317.428 383.744 379.293 341.327C441.167 298.91 451.18 197.022 401.013 120.902C350.846 44.7817 289.438 25.0329 289.438 25.0329V25.0239Z",
    fill: "#92E3A9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M289.438 25.0239C289.438 25.0239 217.568 -1.74667 147.857 38.548C78.1375 78.8517 43.7164 160.158 14.1051 225.27C-15.5152 290.383 2.82843 357.216 56.8202 388.276C110.803 419.328 146.702 375.012 221.886 373.785C297.069 372.558 317.428 383.744 379.293 341.327C441.167 298.91 451.18 197.022 401.013 120.902C350.846 44.7817 289.438 25.0329 289.438 25.0329V25.0239Z",
    fill: "#E8F5E9"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M353.8 236.404L341.57 248.634L353.8 260.863L366.03 248.634L353.8 236.404Z",
    stroke: "black",
    strokeWidth: 0.795956,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.0111 20.2488L77.7812 32.478L90.0111 44.7073L102.241 32.478L90.0111 20.2488Z",
    stroke: "black",
    strokeWidth: 0.795956,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.7809 275.268L60.2188 282.83L67.7809 290.392L75.343 282.83L67.7809 275.268Z",
    stroke: "black",
    strokeWidth: 0.795956,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0387 152.537L17.4766 160.099L25.0387 167.661L32.6008 160.099L25.0387 152.537Z",
    stroke: "black",
    strokeWidth: 0.795956,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.234 65.0139L326.672 72.5757L334.234 80.1374L341.796 72.5757L334.234 65.0139Z",
    stroke: "black",
    strokeWidth: 0.795956,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.7503 283.676L73.9961 294.43L84.7503 305.184L95.5044 294.43L84.7503 283.676Z",
    stroke: "black",
    strokeWidth: 0.795956,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.218 272.211L291.656 279.773L299.218 287.334L306.78 279.773L299.218 272.211Z",
    stroke: "black",
    strokeWidth: 0.795956,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.226 49.5691L342.754 64.0403L357.226 78.5114L371.698 64.0403L357.226 49.5691Z",
    stroke: "black",
    strokeWidth: 0.795956,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.129 391.28L194.566 398.842L202.129 406.403L209.691 398.842L202.129 391.28Z",
    stroke: "black",
    strokeWidth: 0.795956,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5369 163.149C57.6065 163.149 62.5269 158.229 62.5269 152.16C62.5269 146.09 57.6065 141.17 51.5369 141.17C45.4673 141.17 40.5469 146.09 40.5469 152.16C40.5469 158.229 45.4673 163.149 51.5369 163.149Z",
    stroke: "black",
    strokeWidth: 0.795956,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.283 196.735C376.017 196.735 380.664 192.088 380.664 186.355C380.664 180.622 376.017 175.975 370.283 175.975C364.55 175.975 359.902 180.622 359.902 186.355C359.902 192.088 364.55 196.735 370.283 196.735Z",
    stroke: "black",
    strokeWidth: 0.795956,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.534 121.018C410.908 121.018 413.643 118.283 413.643 114.91C413.643 111.537 410.908 108.802 407.534 108.802C404.161 108.802 401.426 111.537 401.426 114.91C401.426 118.283 404.161 121.018 407.534 121.018Z",
    stroke: "black",
    strokeWidth: 0.795956,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.409 34.9298C285.409 32.9056 283.77 31.2666 281.745 31.2666C279.721 31.2666 278.082 32.9056 278.082 34.9298C278.082 36.9539 279.721 38.5929 281.745 38.5929C283.77 38.5929 285.409 36.9539 285.409 34.9298Z",
    stroke: "black",
    strokeWidth: 0.795956,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.531 247.411C133.554 247.411 135.194 245.771 135.194 243.748C135.194 241.725 133.554 240.084 131.531 240.084C129.507 240.084 127.867 241.725 127.867 243.748C127.867 245.771 129.507 247.411 131.531 247.411Z",
    stroke: "black",
    strokeWidth: 0.795956,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.8198 347.552C47.8571 347.552 50.3193 345.09 50.3193 342.052C50.3193 339.015 47.8571 336.553 44.8198 336.553C41.7825 336.553 39.3203 339.015 39.3203 342.052C39.3203 345.09 41.7825 347.552 44.8198 347.552Z",
    stroke: "black",
    strokeWidth: 0.795956,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.611 332.899C377.611 330.203 375.425 328.018 372.729 328.018C370.033 328.018 367.848 330.203 367.848 332.899C367.848 335.595 370.033 337.781 372.729 337.781C375.425 337.781 377.611 335.595 377.611 332.899Z",
    stroke: "black",
    strokeWidth: 0.795956,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.532 17.223C338.532 14.5272 336.347 12.3418 333.651 12.3418C330.955 12.3418 328.77 14.5272 328.77 17.223C328.77 19.9189 330.955 22.1042 333.651 22.1042C336.347 22.1042 338.532 19.9189 338.532 17.223Z",
    stroke: "black",
    strokeWidth: 0.795956,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M143.13 204.671L108.324 223.605",
    stroke: "#263238",
    strokeWidth: 2.38787,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.1797 101.485L114.431 116.137",
    stroke: "#263238",
    strokeWidth: 2.38787,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.758 18.4412L145.574 56.9088",
    stroke: "#263238",
    strokeWidth: 2.38787,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.968 1.34351L201.75 31.8758",
    stroke: "#263238",
    strokeWidth: 2.38787,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.582 74.0065L303.725 42.8652",
    stroke: "#263238",
    strokeWidth: 2.38787,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.934 136.898L342.804 127.736",
    stroke: "#263238",
    strokeWidth: 2.38787,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.289 205.28L312.887 218.106",
    stroke: "#263238",
    strokeWidth: 2.38787,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.82 73.3975L132.137 87.441",
    stroke: "#263238",
    strokeWidth: 2.38787,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.052 99.6484L291.508 108.811",
    stroke: "#263238",
    strokeWidth: 2.38787,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.539 166.203L99.7773 172.312",
    stroke: "#263238",
    strokeWidth: 2.38787,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.844 174.139L308.607 176.584",
    stroke: "#263238",
    strokeWidth: 2.38787,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.203 137.785C303.755 135.393 290.741 137.516 282.509 144.153C274.278 150.789 272.424 153.181 272.424 153.181C272.424 153.181 268.707 127.162 268.707 126.365C268.707 125.568 263.396 76.7201 262.339 69.5551C261.273 62.39 259.687 51.7677 258.093 49.3763C256.499 46.985 250.13 46.7253 248.008 47.7821L245.885 48.8479C245.885 48.8479 246.951 30.2635 244.819 25.7494C242.696 21.2354 236.059 23.8955 234.196 26.2779C232.342 28.6692 231.008 32.3861 231.008 32.3861C231.008 32.3861 224.899 30.2635 221.451 37.1688C218.002 44.0742 215.342 50.1735 214.814 56.8101C214.285 63.4468 211.365 71.9464 211.365 71.9464C211.365 71.9464 207.917 66.3755 204.2 69.5551C200.483 72.7435 196.237 85.2197 195.171 94.2478C194.105 103.276 193.049 127.162 193.049 127.162C193.049 127.162 190.926 138.044 189.86 146.804C188.794 155.563 189.591 191.935 193.577 207.062C197.563 222.198 202.865 231.755 202.865 231.755C202.865 231.755 212.154 262.287 213.488 266.533C214.814 270.778 229.413 328.654 229.413 328.654L272.952 273.438C272.952 273.438 262.07 243.443 259.678 236.538C257.287 229.632 255.693 227.51 255.693 227.51C255.693 227.51 268.967 208.656 276.132 203.086C283.298 197.515 287.015 178.93 288.878 170.699C290.732 162.468 298.435 151.058 302.68 147.341C306.926 143.624 310.643 140.176 307.194 137.785H307.203ZM208.974 125.04C208.177 125.04 208.445 114.686 208.445 102.21C208.445 89.7337 210.568 84.1539 210.568 84.1539C209.502 89.7248 211.634 117.337 211.634 119.2C211.634 121.063 209.78 125.04 208.983 125.04H208.974Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.795956,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.117 232.05C252.44 230.366 253.04 228.575 253.04 228.575",
    stroke: "#263238",
    strokeWidth: 0.795956,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.043 225.924C223.043 225.924 237.643 235.481 244.817 233.627",
    stroke: "#263238",
    strokeWidth: 0.795956,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.425 153.189C272.425 153.189 266.854 161.949 265.519 165.137C264.193 168.326 263.396 170.977 261.005 172.302C258.613 173.628 255.434 175.491 255.434 175.491",
    stroke: "#263238",
    strokeWidth: 0.795956,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.38 155.778C249.627 158.913 240.124 164.457 234.723 172.562",
    stroke: "#263238",
    strokeWidth: 0.795956,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.192 152.652C264.192 152.652 262.249 153.261 259.293 154.497",
    stroke: "#263238",
    strokeWidth: 0.795956,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.804 176.02C231.804 176.02 227.021 184.779 224.898 191.684",
    stroke: "#263238",
    strokeWidth: 0.795956,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.006 32.395C231.006 32.395 229.68 43.5457 227.817 60.2672C225.963 76.9888 224.897 85.2197 225.166 95.8419C225.435 106.464 228.355 115.752 228.086 117.077",
    stroke: "#263238",
    strokeWidth: 0.795956,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.875 48.8567C245.875 48.8567 245.078 55.7621 245.875 64.7811C246.672 73.8091 245.078 90.5307 245.078 96.9076C245.078 103.285 245.347 112.832 245.607 115.752C245.866 118.672 247.461 120.794 247.461 120.794",
    stroke: "#263238",
    strokeWidth: 0.795956,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.918 122.389C250.918 122.389 252.244 124.78 261.003 125.04",
    stroke: "#263238",
    strokeWidth: 0.795956,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.738 116.021C230.738 116.021 237.107 117.346 241.361 116.549",
    stroke: "#263238",
    strokeWidth: 0.795956,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.64 127.171C207.64 127.171 207.64 129.822 199.938 132.214",
    stroke: "#263238",
    strokeWidth: 0.795956,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.777 119.997C223.575 119.469 226.763 118.403 227.56 114.686",
    stroke: "#263238",
    strokeWidth: 0.795956,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.234 160.668C223.234 160.668 239.742 154.613 250.194 152.41",
    stroke: "#263238",
    strokeWidth: 0.795956,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.094 429.368H412.812C402.843 416.211 366.46 368.268 364.087 365.904C361.337 363.154 349.227 361.506 349.227 361.506L313.463 331.798L268.894 258.069L226.528 316.939L219.371 288.323L203.41 347.749C203.41 347.749 261.191 418.182 263.385 420.931C263.815 421.469 266.305 424.621 270.085 429.377L270.094 429.368Z",
    fill: "#191919",
    stroke: "#263238",
    strokeWidth: 0.795956,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.338 222.96C158.338 222.96 146.524 192.705 143.675 187.134C140.827 181.563 125.367 157.372 124.588 150.807C123.809 144.242 121.391 133.324 118.901 128.757C116.411 124.189 123.827 121.197 129.962 126.983C136.089 132.769 139.797 142.182 139.716 144.896C139.636 147.61 153.474 157.748 153.474 157.748L155.991 134.426C155.991 134.426 158.678 76.5768 158.114 67.9429C157.549 59.309 156.994 40.9753 163.846 40.2677C170.698 39.5602 171.764 44.9788 171.764 44.9788C171.764 44.9788 172.006 31.3203 179.628 32.198C185.45 32.8698 187.68 38.36 188.531 41.0021C189.382 43.6443 190.385 46.9223 190.385 46.9223C190.385 46.9223 195.186 43.6622 199.87 51.4274C202.557 55.8876 208.272 69.9133 209.194 73.4779C210.117 77.0426 210.404 78.3323 210.404 78.3323C210.404 78.3323 216.826 78.1263 219.674 84.9063C222.522 91.6862 226.571 109.375 230.485 124.01C234.399 138.644 234.238 152.545 234.238 152.545C234.238 152.545 235.769 199.628 232.617 214.603C229.464 229.578 223.534 242.341 222.316 243.559C221.098 244.777 203.578 296.474 203.578 296.474L142.815 273.948C142.815 273.948 155.471 242.861 157.469 236.081C159.475 229.31 158.338 222.96 158.338 222.96Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.795956,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.629 178.832C145.754 181.796 146.39 183.578 146.39 183.578",
    stroke: "#263238",
    strokeWidth: 0.795956,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.621 160.328C151.621 160.328 148.191 164.322 146.408 171.452C146.05 172.885 145.835 174.228 145.719 175.464",
    stroke: "#263238",
    strokeWidth: 0.795956,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.765 44.9968C171.765 44.9968 172.822 63.7604 173.52 73.0303C174.228 82.3001 174.568 96.6392 174.631 106.061C174.694 115.474 173.547 127.315 172.902 129.885C172.257 132.456 170.824 135.734 170.824 135.734",
    stroke: "#263238",
    strokeWidth: 0.795956,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.376 46.9404C190.376 46.9404 187.376 50.4334 188.37 54.9295C189.364 59.4256 193.977 84.5393 193.977 88.1756C193.977 91.8118 194.237 123.41 194.299 125.55C194.371 127.691 192.866 134.892 192.15 137.749",
    stroke: "#263238",
    strokeWidth: 0.795956,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.398 78.3413C210.398 78.3413 206.977 78.6906 207.756 84.0465C208.535 89.4024 210.237 106.805 210.228 111.65C210.228 116.504 211.357 127.7 211.133 138.259C210.909 148.819 213.336 152.455 214.474 155.169",
    stroke: "#263238",
    strokeWidth: 0.795956,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.553 148.774C157.553 148.774 156.334 154.838 157.973 157.972C159.613 161.116 161.888 167.744 161.888 171.389",
    stroke: "#263238",
    strokeWidth: 0.795956,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.82 145.792C169.82 145.792 169.175 150.78 169.882 153.996C170.59 157.211 172.802 160.489 172.802 160.489",
    stroke: "#263238",
    strokeWidth: 0.795956,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.29 153.655C190.29 153.655 189.573 158.931 190.854 162.289C192.135 165.639 193.631 168.138 193.631 168.138",
    stroke: "#263238",
    strokeWidth: 0.795956,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.737 429.368L219.227 301.91C219.227 301.91 195.125 282.009 179.271 271.566C163.418 261.123 144.402 261.436 144.402 261.436C144.402 261.436 119.583 314.324 118.284 317.691C116.976 321.059 99.6717 356.893 99.6717 356.893C99.6717 356.893 92.0674 359.607 88.6907 365.68C86.0484 370.444 66.9793 411.724 58.8555 429.368H162.737Z",
    fill: "#007A37",
    stroke: "#263238",
    strokeWidth: 0.795956,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.708 310.277C205.211 308.796 206.04 305.566 204.56 303.063C203.079 300.559 199.849 299.73 197.346 301.211C194.842 302.691 194.013 305.921 195.493 308.424C196.974 310.928 200.204 311.757 202.708 310.277Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.795956,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.187 326.719C196.479 329.541 193.622 331.251 190.801 330.544C187.979 329.836 186.268 326.979 186.976 324.158C187.684 321.337 190.541 319.626 193.362 320.333C196.184 321.041 197.894 323.898 197.187 326.719Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.795956,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2472_1937"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 433,
    height: 429.816,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandshake);
export default __webpack_public_path__ + "static/media/handshake.ff8c333bcac9eb23d8490337783d02c6.svg";
export { ForwardRef as ReactComponent };